import React, { useId } from 'react';
const BASE_CONTROL = 'w-full min-h-[44px] rounded-xl border border-linea bg-white px-3 py-2 text-sm text-tinta placeholder:text-tinta-tenue focus:border-vino focus:outline-none focus:ring-2 focus:ring-vino/20';
interface BaseProps {
  etiqueta: string;
  ayuda?: string;
  error?: string;
  requerido?: boolean;
}
export function CampoTexto({
  etiqueta,
  ayuda,
  error,
  requerido,
  ...props
}: BaseProps & React.InputHTMLAttributes<HTMLInputElement>) {
  const id = useId();
  return <div data-id="element-397" data-mp="23o0rk9nca13s">
      <label htmlFor={id} className="mb-1 block text-sm font-semibold text-tinta-titulo" data-id="element-398" data-mp="23mpqihla37gd">
        {etiqueta}
        {requerido && <span className="ml-1 text-alerta" data-id="element-399" data-mp="1pnhq5lddptal">*</span>}
      </label>
      <input id={id} {...props} aria-invalid={Boolean(error)} aria-describedby={ayuda || error ? `${id}-ayuda` : undefined} className={`${BASE_CONTROL} ${error ? 'border-alerta' : ''}`} data-id="element-400" data-mp="1umb0j4xdd46j" />
      {(ayuda || error) && <p id={`${id}-ayuda`} className={`mt-1 text-xs ${error ? 'font-semibold text-alerta' : 'text-tinta-tenue'}`} data-id="element-401" data-mp="2gxvoiqq5z31k">
          {error || ayuda}
        </p>}
    </div>;
}
export function CampoArea({
  etiqueta,
  ayuda,
  error,
  requerido,
  ...props
}: BaseProps & React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const id = useId();
  return <div data-id="element-402" data-mp="2lzbb4n7zphm2">
      <label htmlFor={id} className="mb-1 block text-sm font-semibold text-tinta-titulo" data-id="element-403" data-mp="2zwq2hxhszzgo">
        {etiqueta}
        {requerido && <span className="ml-1 text-alerta" data-id="element-404" data-mp="2uyeulsb2jz13">*</span>}
      </label>
      <textarea id={id} rows={3} {...props} aria-describedby={ayuda || error ? `${id}-ayuda` : undefined} className={`${BASE_CONTROL} ${error ? 'border-alerta' : ''}`} data-id="element-405" data-mp="2uvslho8j5bgr" />
      {(ayuda || error) && <p id={`${id}-ayuda`} className={`mt-1 text-xs ${error ? 'font-semibold text-alerta' : 'text-tinta-tenue'}`} data-id="element-406" data-mp="3io94q24079hn">
          {error || ayuda}
        </p>}
    </div>;
}
interface CampoSelectProps extends BaseProps, React.SelectHTMLAttributes<HTMLSelectElement> {
  opciones: readonly string[];
}
export function CampoSelect({
  etiqueta,
  ayuda,
  error,
  requerido,
  opciones,
  ...props
}: CampoSelectProps) {
  const id = useId();
  return <div data-id="element-407" data-mp="48knmv4imk0c">
      <label htmlFor={id} className="mb-1 block text-sm font-semibold text-tinta-titulo" data-id="element-408" data-mp="49dxi4yrtpmp">
        {etiqueta}
        {requerido && <span className="ml-1 text-alerta" data-id="element-409" data-mp="89efu0ozqkz1">*</span>}
      </label>
      <select id={id} {...props} aria-describedby={ayuda || error ? `${id}-ayuda` : undefined} className={`${BASE_CONTROL} ${error ? 'border-alerta' : ''}`} data-id="element-410" data-mp="d87q7k8zdvuz">
        {opciones.map(o => <option key={o} value={o} data-id="element-411" data-mp="n6on0xulp4oy">
            {o}
          </option>)}
      </select>
      {(ayuda || error) && <p id={`${id}-ayuda`} className={`mt-1 text-xs ${error ? 'font-semibold text-alerta' : 'text-tinta-tenue'}`} data-id="element-412" data-mp="2k1tfwido3zi2">
          {error || ayuda}
        </p>}
    </div>;
}
export function CampoNumero({
  etiqueta,
  ayuda,
  error,
  requerido,
  ...props
}: BaseProps & React.InputHTMLAttributes<HTMLInputElement>) {
  return <CampoTexto etiqueta={etiqueta} ayuda={ayuda} error={error} requerido={requerido} type="number" inputMode="numeric" {...props} data-id="element-413" data-mp="xbn4729lnq7j" />;
}
export function Casilla({
  etiqueta,
  checked,
  onChange,
  descripcion
}: {
  etiqueta: string;
  checked: boolean;
  onChange: (v: boolean) => void;
  descripcion?: string;
}) {
  const id = useId();
  return <div className="flex min-h-[44px] items-start gap-3" data-id="element-414" data-mp="1g01utog0927t">
      <input id={id} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} className="mt-1 h-5 w-5 shrink-0 rounded border-linea accent-[#4CAF50]" data-id="element-415" data-mp="1b31odcf8txg6" />
      <label htmlFor={id} className="cursor-pointer text-sm text-tinta" data-id="element-416" data-mp="3vrpqlgja8op1">
        {etiqueta}
        {descripcion && <span className="mt-0.5 block text-xs text-tinta-tenue" data-id="element-417" data-mp="1nj9gnk5910hs">{descripcion}</span>}
      </label>
    </div>;
}